import React, { FunctionComponent } from 'react'
import { generatePath, Navigate, Route, Routes } from 'react-router'

import { getAccountInputs, useConfig } from '../../state/configuration'
import { AppPath } from '../AppPath'
import { ProtectedRoutes } from '../authentication'
import { AccountPath } from './AccountPath'
import { AccountSetting } from './AccountSetting'
import { AccountSettings } from './AccountSettings'

export const AccountRouter: FunctionComponent = () => {
  const accountInputs = useConfig(getAccountInputs)

  return accountInputs.length ? (
    <ProtectedRoutes>
      <Routes>
        <Route index element={<AccountSettings />} />

        {accountInputs.map((input) => (
          <Route
            key={input.name}
            path={generatePath(AccountPath.ACCOUNT_SETTING, input)}
            element={<AccountSetting input={input} />}
          />
        ))}

        <Route path='*' element={<Navigate to={AppPath.HOME} />} />
      </Routes>
    </ProtectedRoutes>
  ) : (
    <Navigate to={AppPath.HOME} />
  )
}
